import { svg } from "lit";
const icon = svg `<path d="M18.953 7.5V28.5064L8.97433 18.5171L7.5 20L20 32.4999L32.4999 20L31.0256 18.5171L21.0469 28.5064V7.5H18.953Z" fill="currentColor"/>`;
export default icon;
